<button mat-button [matMenuTriggerFor]="menu">{{ label }}</button>
<mat-menu #menu="matMenu" id="genericListMenu-menu-{{ testingId | camelCase }}">
  <button
    mat-menu-item
    id="genericListMenu-button-{{ testingId | camelCase }}-{{ choice | camelCase }}"
    *ngFor="let choice of choices"
    (click)="handleMenuItemClicked(choice)"
  >
    {{ choice }}
  </button>
</mat-menu>
